import Vue from 'vue';

export default {
    namespaced: true,

    state: {
        namespaces: {},
    },

    getters: {
        get(state) {
            return (ns, count = null) => {
                let items = state.namespaces[ns] || [];
                if (items.length > 0 && count !== null) {
                    items = state.namespaces[ns].slice(-count);
                }
                return items;
            };
        },

        getCount(state) {
            return ns => state.namespaces.hasOwnProperty(ns) ? state.namespaces[ns].length : 0;
        },
    },

    mutations: {
        push(state, {ns, id, data = {}, listeners = {}}) {
            if (!state.namespaces.hasOwnProperty(ns)) {
                Vue.set(state.namespaces, ns, []);
            }
            state.namespaces[ns].push({id, data, listeners});
        },

        remove(state, {ns, id}) {
            if (!state.namespaces.hasOwnProperty(ns)) {
                return;
            }
            state.namespaces[ns] = state.namespaces[ns].filter(item => item.id !== id);
        },

        clear(state, ns) {
            Vue.set(state.namespaces, ns, []);
        },
    },
};